import RadioInputGroup from '../ui-components/RadioInputGroup'

const CategoryDefaultSetting = (props) => {
  const options = [
    'Show all categories',
    <p>Collapse all categories - <i>Recommended if you have many (parent) categories.</i></p>
  ]

  return (
    <div className='homepage-category-setting'>
      <RadioInputGroup
        title='Category list default setting'
        meta='Define how users will see the category list upon their first visit.'
        options={options}
        onChange={(e) => props.onChange(e !== 'Show all categories')}
        value={!props.collapsed ? options[0] : options[1]} />
    </div>
  )
}

export default CategoryDefaultSetting
